import initialProductState from "../product.initialState";
import { reduxActions as PRODUCT } from "_constants/product.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const details = {
  [PRODUCT.DETAILS_STARTED]: (state) => ({
    ...state,
    details: {
      ...state.details,
      status: LOADING
    }
  }),
  [PRODUCT.DETAILS_FAIL]: (state, { payload }) => ({
    ...state,
    details: {
      ...state.details,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),
  [PRODUCT.DETAILS_SUCCESS]: (state, { payload }) => ({
    ...state,
    details: {
      ...state.details,
      data: payload?.data?.[0] ?? null,
      status: SUCCESS
    }
  }),

  [PRODUCT.DETAILS_REFRESH]: (state, { payload }) => {
    let newState = {...state.details.data};
    if (!newState) return state;
    
    if (newState?._id === payload?._id) {
      newState = { ...newState, ...payload.c };
    }
    
    return {
      ...state,
      details: {
        ...state.details,
        data: newState
      }
    };
  },

  [PRODUCT.DETAILS_RESET]: (state) => ({
    ...state,
    details: initialProductState.details
  })
};

export default details;
